export default __webpack_public_path__ + "static/media/fof-leadership.336a18bf.svg";